import React from 'react'
import { injectIntl } from 'react-intl'

import CheckedIcon from '../../assets/checked.svg'
import DataQualificationIcon from '../../assets/products/funnel.svg'
import BoletoIcon from '../../assets/products/barcode.svg'
import PixIcon from '../../assets/products/pix.svg'
import BankTransferIcon from '../../assets/products/send.svg'
import * as S from './RegisterWizard.styled'

const Step3Prices = ({ intl, ...props }) => {
  return (
    <S.Step3>
      <h2 className="header-page-create-account" dangerouslySetInnerHTML={{ __html: intl.messages.register.step3.title }} />

      <S.Alert>
        <div className="icon"><CheckedIcon /></div>
        <div className="info">
          <div className="title">{intl.messages.register.step3.success_title}</div>
          <div className="message">{intl.messages.register.step3.success_text}</div>
        </div>
      </S.Alert>

      <button 
        onClick={props.nextStep}
        className="button-next-wizard">
        {intl.messages.register.step3.show_next_steps}
      </button>

      <div className="text-prices">
        {Object.values(intl.messages.register.step3.text1).map((text, key) => (
          <p key={key} dangerouslySetInnerHTML={{ __html: text }} />
        ))}
      </div>

      {/* <h2>{intl.messages.register.step3.prices.title}</h2> */}

      <S.GridProducts>

        <div className="card-product border-card">
          <div className="card-product__name"><DataQualificationIcon /><div>{intl.messages.register.step3.prices.dataqualification.title}</div></div>
          <S.PriceWithCommercial>
            <div className="card-price">
              <div className="card-price__symbol">R$</div>
              <div className="card-price__text" dangerouslySetInnerHTML={{ __html: intl.messages.register.step3.prices.title }} />
            </div>
          </S.PriceWithCommercial>
          {/* <div style={{ display: 'flex' }}>
            <S.Price className="small" style={{ marginBottom: 17 }}>
              <div className="price">{intl.messages.register.step3.prices.dataqualification.prices[0]}</div>
              <div className="per_unit">{intl.messages.register.step3.prices.dataqualification.per_validation}</div>
            </S.Price>
            <S.Price className="small" style={{ marginBottom: 17 }}>
              <div className="price">{intl.messages.register.step3.prices.dataqualification.prices[1]}</div>
              <div className="per_unit">{intl.messages.register.step3.prices.dataqualification.per_payment}</div>
            </S.Price>
          </div>
          <S.Price className="small" style={{ marginBottom: 25 }}>
            <div className="price">{intl.messages.register.step3.prices.dataqualification.prices[2]}</div>
            <div className="per_unit">{intl.messages.register.step3.prices.dataqualification.per_manual_validation}</div>
          </S.Price> */}
          <ul className="card-product__features">
            {Object.values(intl.messages.register.step3.prices.dataqualification.features).map((value, keyFeature) => (
              <li key={keyFeature} dangerouslySetInnerHTML={{ __html: value }} />
            ))}
          </ul>
        </div>

        <div className="card-product border-card">
          <div className="card-product__name"><PixIcon /><div>{intl.messages.register.step3.prices.pix.title}</div></div>
          <S.PriceWithCommercial>
            <div className="card-price">
              <div className="card-price__symbol">R$</div>
              <div className="card-price__text" dangerouslySetInnerHTML={{ __html: intl.messages.register.step3.prices.title }} />
            </div>
          </S.PriceWithCommercial>
          <ul className="card-product__features">
            {Object.values(intl.messages.register.step3.prices.pix.features).map((value, keyFeature) => (
              <li {...(keyFeature === 0 && { style: { fontWeight: 'bold', color: '#0098f2' }})} key={keyFeature} dangerouslySetInnerHTML={{ __html: value }} />
            ))}
          </ul>
        </div>

        <div className="card-product border-card">
          <div className="card-product__name"><BankTransferIcon /><div>{intl.messages.register.step3.prices.ted.title}</div></div>
          {/* <S.Price>
            <div className="price">{intl.messages.register.step3.prices.ted.prices[0]}</div>
            <div className="per_unit">{intl.messages.register.step3.prices.ted.per_pay}</div>
            <div className="obs">{intl.messages.register.step3.prices.ted.obs_price}</div>
          </S.Price> */}
          <S.PriceWithCommercial>
            <div className="card-price">
              <div className="card-price__symbol">R$</div>
              <div className="card-price__text" dangerouslySetInnerHTML={{ __html: intl.messages.register.step3.prices.title }} />
            </div>
          </S.PriceWithCommercial>
          <ul className="card-product__features">
            {Object.values(intl.messages.register.step3.prices.ted.features).map((value, keyFeature) => (
              <li key={keyFeature} dangerouslySetInnerHTML={{ __html: value }} />
            ))}
          </ul>
        </div>

        <div className="card-product border-card">
          <div className="card-product__name"><BoletoIcon /><div>{intl.messages.register.step3.prices.boleto.title}</div></div>
          {/* <S.Price>
            <div className="price">{intl.messages.register.step3.prices.boleto.prices[0]}</div>
            <div className="per_unit">{intl.messages.register.step3.prices.boleto.per_pay}</div>
            <div className="obs">{intl.messages.register.step3.prices.boleto.obs_price}</div>
          </S.Price> */}
          <S.PriceWithCommercial>
            <div className="card-price">
              <div className="card-price__symbol">R$</div>
              <div className="card-price__text" dangerouslySetInnerHTML={{ __html: intl.messages.register.step3.prices.title }} />
            </div>
          </S.PriceWithCommercial>
          <ul className="card-product__features">
            {Object.values(intl.messages.register.step3.prices.boleto.features).map((value, keyFeature) => (
              <li key={keyFeature} dangerouslySetInnerHTML={{ __html: value }} />
            ))}
          </ul>
        </div>
        
      </S.GridProducts>

    </S.Step3>
  )
}

export default injectIntl(Step3Prices)